import { Box } from "@mui/material";
import AboutHeroSection from "./sections/AboutHeroSection";
import WhoWeAreSection from "./sections/WhoWeAreSection";
import VisionSection from "./sections/VisionSection";
import CompanyHistorySection from "./sections/CompanyHistorySection";
import TeamSection from "./sections/TeamSection";
import AboutCtaSection from "./sections/AboutCtaSection";

const About = () => (
  <Box sx={{ overflow: "hidden" }}>
    <AboutHeroSection />
    <WhoWeAreSection />
    <VisionSection />
    <CompanyHistorySection />
    <TeamSection />
    <AboutCtaSection />
  </Box>
);

export default About;
